const ALL_FILTERS = ["New", "Pre-owned", "Loaners", "Fleet"];
const NO_PREOWNED_FILTER = ["New", "Loaners"];
const UNITS_ON_SCHEDULE_FILTER = ["New", "Pre-owned", "Loaners"];
const UNITS_ON_MFG_FILTER = ["New", "Loaners"];

const VEHICLE_PROPERTIES = ["type", "vinNumber", "stockNumber", "year", "make", "model", "color"] as const;
const REASONS_RESOLUTION_PROPERTIES = ["reason", "resolution"] as const;

const DEFAULT_REASON = "No reason provided";
const DEFAULT_RESOLUTION = "No resolution provided";

enum ReconciliationStatus {
	UNITS_ON_LOT = "Units on Lot",
	UNITS_OFF_LOT = "Units off Lot",
	UNITS_ON_MFG = "Units on Mfg",
	UNITS_ON_SCHEDULE = "Units on Schedule",

	ON_MFG_NOT_ON_LOT = "On Mfg not on Lot",
	ON_SCH_NOT_ON_LOT = "On Sch not on Lot",

	ON_LOT_NOT_ON_SCH = "On Lot not on Sch",
	ON_LOT_NOT_ON_MFG = "On Lot not on Mfg",

	OFF_LOT_NOT_ON_SCH = "Off Lot not on Sch",
	OFF_LOT_NOT_ON_MFG = "Off Lot not on Mfg",
}

const DEFAULT_OBJECT_STATUS = {
	status: "",
	startDate: null,
	endDate: null,
	error: "",
};

const DEFAULT_RECONCILIATION_STATUS = {
	newVehicleReconciliation: DEFAULT_OBJECT_STATUS,
	usedVehicleReconciliation: DEFAULT_OBJECT_STATUS,
};

const FLEET_VEHICLE_TYPES = ["rental", "parts", "shuttle"];

export {
	ALL_FILTERS,
	NO_PREOWNED_FILTER,
	VEHICLE_PROPERTIES,
	REASONS_RESOLUTION_PROPERTIES,
	DEFAULT_REASON,
	DEFAULT_RESOLUTION,
	ReconciliationStatus,
	UNITS_ON_SCHEDULE_FILTER,
	UNITS_ON_MFG_FILTER,
	DEFAULT_RECONCILIATION_STATUS,
	FLEET_VEHICLE_TYPES,
};
